import { Navigate, Route, Routes } from "react-router-dom";

import Layout from "./components/layout/Layout";
import * as PublicPages from "./pages/public/Pages";
import RequireAuth from "./components/auth/RequireAuth";
import * as AdminPages from "./pages/private/admin/Pages";
import * as CommonPages from "./pages/private/common/Pages";
import * as PharmaciesPages from "./pages/private/pharmacies/Pages";
import * as AlphegaCentralePages from "./pages/private/alphega_centrale/Pages";
import * as TablesPages from "./tables/TablesPages"

import "./App.css";

const ROLES = {
  Generic: "5761",
  Admin: "6957",
  Alphega_Centrale: "4719",
  Farmacia: "8632",
};

function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        {/*\\\\\\\\ public routes \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\*/}
        <Route path="" element={<Navigate to="/login" />} />
        <Route path="login" element={<PublicPages.Login />} />

        <Route path="*" element={<PublicPages.Missing />} />
        <Route path="unauthorized" element={<PublicPages.Unauthorized />} />

        <Route path="area_cliente" element={<Layout />}>

          <Route
            path="accesso/:key"
            element={<PublicPages.PharmaciesAccessRedirect />}
          />
          <Route
            path="accesso/:key/richiedi_nuovo_link"
            element={<PublicPages.PharmaciesNewAccessLinkRequest />}
          />
          <Route
            path="accesso_comunicazione/:key"
            element={<PublicPages.PharmaciesAccessToPromotionRedirect />}
          />
          
        </Route>

        {/*\\\\\\\\ private routes \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\*/}
        {/* common pages \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\*/}
        <Route path="profilo" element={<Layout />}>
          <Route element={<RequireAuth allowedRoles={ROLES.Generic} />}>
            <Route
              path=""
              element={<CommonPages.Profile action={{ value: "no-edit" }} />}
            />
          </Route>

          <Route element={<RequireAuth allowedRoles={ROLES.Generic} />}>
            <Route
              path="modifica"
              element={<CommonPages.Profile action={{ value: "edit" }} />}
            />
          </Route>

          <Route element={<RequireAuth allowedRoles={ROLES.Generic} />}>
            <Route
              path="modifica_password"
              element={<CommonPages.Profile action={{ value: "edit-psw" }} />}
            />
          </Route>
        </Route>

        {/* admin pages \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\*/}
        {/* <Route path="admin" element={<Layout />}> */}
          {/* <Route element={<RequireAuth allowedRoles={ROLES.Admin} />}>
            <Route path="" element={<AdminPages.AdminHome />} />
          </Route>

          <Route path="roles" element={<Layout />}>
            <Route element={<RequireAuth allowedRoles={ROLES.Admin} />}>
              <Route path="" element={<AdminPages.AdminRolesList />} />
            </Route>

            <Route element={<RequireAuth allowedRoles={ROLES.Admin} />}>
              <Route
                path="detail/:idRole"
                element={<AdminPages.AdminRolesDetail />}
              />
            </Route>
          </Route> */}

          
          <Route element={<RequireAuth allowedRoles={ROLES.Admin} />}>

            <Route path="admin_home" element={<AdminPages.AdminHome/>} />

            <Route path="tables" element={<TablesPages.Tables roles={ROLES.Admin}/>} />

            <Route path="tables/user" element={<Layout />}>
              <Route path="user_tokens" element={<TablesPages.User_Tokens roles={ROLES.Admin} />} />
              <Route path="user_relationships" element={<TablesPages.User_Relationships roles={ROLES.Admin} />} />
              <Route path="user_anagraphics" element={<TablesPages.User_Anagraphics roles={ROLES.Admin} />} />
              <Route path="users" element={<TablesPages.Users roles={ROLES.Admin} showInactive="false" />} />
              <Route path="users/inactive" element={<TablesPages.Users roles={ROLES.Admin} showInactive="true" />} />
              <Route path="roles" element={<TablesPages.Roles roles={ROLES.Admin} />} />
            </Route>

            <Route path="tables/promotion" element={<Layout />}>
              <Route path="promotion_typologies" element={<TablesPages.Promotion_Typologies roles={ROLES.Admin} />} />
              <Route path="promotion_components" element={<TablesPages.Promotion_Components roles={ROLES.Admin} />} />
              <Route path="promotion_attachments" element={<TablesPages.Promotion_Attachments roles={ROLES.Admin} />} />
              <Route path="promotion_assignments" element={<TablesPages.Promotion_Assignments roles={ROLES.Admin} />} />
              <Route path="promotion_answers" element={<TablesPages.Promotion_Answers roles={ROLES.Admin} />} />
              <Route path="promotions" element={<TablesPages.Promotions roles={ROLES.Admin} />} />
              <Route path="input_types" element={<TablesPages.Input_Types roles={ROLES.Admin} />} />
              <Route path="assignment_states" element={<TablesPages.Assignment_States roles={ROLES.Admin} />} />
            </Route>

            <Route path="tables/file" element={<Layout />}>
              <Route path="file_types" element={<TablesPages.File_Types roles={ROLES.Admin} />} />
              <Route path="files" element={<TablesPages.Files roles={ROLES.Admin} />} />
            </Route>

            <Route path="tables/cluster" element={<Layout />}>
              <Route path="cluster_types" element={<TablesPages.Cluster_Types roles={ROLES.Admin} />} />
              <Route path="cluster_elements" element={<TablesPages.Cluster_Elements roles={ROLES.Admin} />} />
              <Route path="cluster_centroids" element={<TablesPages.Cluster_Centroids roles={ROLES.Admin} />} />
            </Route>

            <Route path="tables/bot" element={<Layout />}>
              <Route path="chat_types" element={<TablesPages.Chat_Types roles={ROLES.Admin} />} />
              <Route path="chat_messages" element={<TablesPages.Chat_Messages roles={ROLES.Admin} />} />
              <Route path="chats" element={<TablesPages.Chats roles={ROLES.Admin} />} />
            </Route>

          </Route>

        {/* </Route> */}
        {/* pharmacies pages \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\*/}

        <Route
          element={
            <RequireAuth allowedRoles={ROLES.Admin + ";" + ROLES.Farmacia} />
          }
        >
          <Route path="pharmacies_promotions" element={<Layout />}>
            <Route path="" element={<PharmaciesPages.PharmaciesPromotions />} />

            <Route
              path=":idPromotion"
              element={<PharmaciesPages.PharmaciesPromotionsDetail />}
            />
          </Route>

          <Route
            path="pharmacies_upload"
            element={<PharmaciesPages.PharmaciesUpload />}
          />
          <Route
            path="pharmacies_home"
            element={<PharmaciesPages.PharmaciesHome />}
          />
          <Route
            path="profile"
            element={<PharmaciesPages.PharmaciesProfile />}
          />
        </Route>

        {/* alphega centrale pages \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\*/}

        <Route path="alphega_centrale" element={<Layout />}>
          <Route
            element={
              <RequireAuth
                allowedRoles={ROLES.Alphega_Centrale + ";" + ROLES.Admin}
              />
            }
          >
            <Route
              path="alphega_home"
              element={<AlphegaCentralePages.AlphegaHome />}
            />

            <Route path="alphega_promotions" element={<Layout />}>
              <Route
                path=""
                element={<AlphegaCentralePages.AlphegaPromotions />}
              />

              <Route
                path=":idPromotion"
                element={<AlphegaCentralePages.AlphegaPromotionsDetail />}
              />

              <Route
                path=":idPromotion/alphega_promotion_assignment/"
                element={<AlphegaCentralePages.AlphegaPromotionAssignment />}
              />
            </Route>

            <Route path="alphega_users" element={<Layout />}>
              <Route path="" element={<AlphegaCentralePages.AlphegaUsers />} />

              <Route path="alphega_create_user" element={<AlphegaCentralePages.AlphegaCreateUser />} />

              <Route
                path="deactivated"
                element={<AlphegaCentralePages.AlphegaUsersDeactivated />}
              />

              <Route
                path=":idUser"
                element={<AlphegaCentralePages.AlphegaUsersDetail />}
              />

              <Route
                path="deactivated/:idUser"
                element={<AlphegaCentralePages.AlphegaUsersDetail />}
              />

              <Route
                path=":idUser/:idPromotion"
                element={<AlphegaCentralePages.AlphegaPromotionsDetail />}
              />
            </Route>

            <Route
              path="alphega_create_promotion"
              element={<AlphegaCentralePages.AlphegaCreatePromotion />}
            />

            <Route
              path="profile"
              element={<AlphegaCentralePages.AlphegaProfile />}
            />

            <Route
              path="files"
              element={<AlphegaCentralePages.AlphegaFiles />}
            />
          </Route>
        </Route>
      </Route>
    </Routes>
  );
}

export default App;
